





















import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";
import { EntryFarmasiResep } from "@/store/modules/resep";

@Component
export default class ResepStatusFarmasi extends Vue {
  @Prop({ required: true }) readonly resep!: {
    status: number;
    no_antri?: string | null;
    antrian_label?: string | null;
    entry_farmasi?: EntryFarmasiResep[];
  };

  get sudahEntry(): boolean {
    return !!this.resep.entry_farmasi && this.resep.entry_farmasi.length > 0;
  }

  get ringkasanTransaksi(): string {
    return (this.resep.entry_farmasi || [])
      .map(entry => {
        const waktu = [moment(entry.tgl).format("DD-MM-YYYY"), entry.jam ? entry.jam.slice(0, 5) : ""]
          .filter(Boolean)
          .join(" ");
        return `${entry.no_transaksi} (${waktu})`;
      })
      .join(", ");
  }

  get labelAntrian(): string | null {
    if (this.resep.antrian_label) {
      return this.resep.antrian_label;
    }
    return this.resep.no_antri && this.resep.no_antri !== "0" ? this.resep.no_antri : null;
  }
}
